import type { MfgUnit } from "@/lib/manufacturing/types";

/** Comma-delimited terms; a unit matches when every non-empty term hits the haystack. */
export function parseBuildPipelineSearchTerms(raw: string): string[] {
  return raw
    .split(",")
    .map((t) => t.trim().toLowerCase())
    .filter(Boolean);
}

export function buildPipelineUnitSearchHaystack(unit: MfgUnit): string {
  const parts = [
    unit.display_label,
    unit.serial,
    unit.notes,
    unit.sale_path,
    unit.origin,
    unit.ops_deal_id,
    unit.end_customer_contact_id,
    unit.customer_name,
    unit.seller_location_id,
    unit.seller_location_name,
    unit.deal_display_name,
    unit.id,
    unit.recipe_id,
    unit.plant_id,
  ];
  return parts
    .filter((v): v is string => typeof v === "string" && v.trim().length > 0)
    .join(" ")
    .toLowerCase();
}

export function unitMatchesBuildPipelineSearch(unit: MfgUnit, terms: readonly string[]): boolean {
  if (terms.length === 0) return true;
  const hay = buildPipelineUnitSearchHaystack(unit);
  return terms.every((t) => hay.includes(t));
}
